import React from "react";
import { FormItem } from "..";
import PropTypes from "prop-types";
import { InputGroup } from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import ja from "date-fns/locale/ja";
registerLocale("ja", ja);
const moment = require("moment");

const keycode = require("keycode");
const BACKSPACE_KEY = 8;

const validations = ["date", "self:validDate"];
class DateText extends FormItem {
  static propTypes = FormItem.extendPropTypes({
    placeholder: PropTypes.string
  });
  static detepickerDefaults = {
    // onChangeはthis.onChageを使用している
    // classNameはpropsで受けたclassNameとdefaultClassNameのクラスを結合して使用している
    placeholderText: "",
    dateFormat: "yyyy/MM/dd",
    locale: "ja",
    isClearable: true
  };
  // validations: ['date'];
  constructor(props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
    self.onChange = self.onChange.bind(self);
    self.getDatepickerOption = self.getDatepickerOption.bind(self);
    self.datepickerRef = React.createRef();
  }
  componentDidMount() {
    const self = this;
    // input要素にreadonlyをつけることで、ソフトキーボードを阻害
    if (self.datepickerRef.current) {
      self.datepickerRef.current.input.readOnly = true;
    }
  }
  validDate() {
    const self = this;
    const val = self.getVal();
    const label = self.getItemLabel();
    const valMoment = moment(new Date(val));
    const { minDate, maxDate, excludeDates } = self.props;
    return new Promise((resolve, reject) => {
      if (minDate && valMoment.isBefore(minDate)) {
        reject(`ご指定の日付（${val}）は${label}として選択できません。`);
        return;
      }
      if (maxDate && valMoment.isAfter(maxDate)) {
        reject(`ご指定の日付（${val}）は${label}として選択できません。`);
        return;
      }
      // if (excludeDates && excludeDates.length >= 1) {
      //   for (let i = 0, l = excludeDates.length; i < l; i++) {
      //     if (valMomemt.isSame(excludeDates[i])) {
      //       reject(`ご指定の日付（${val}）は${label}として選択できません。`);
      //       return;
      //     }
      //   }
      // }
      resolve();
    });
  }
  onChange(selectDate) {
    const self = this;
    const { dateFormat } = self.getDatepickerOption();
    self.setVal(selectDate ? format(selectDate, dateFormat) : "");
    if (typeof self.props.onChange === "function") {
      self.props.onChange(selectDate);
    }
  }
  getDatepickerOption() {
    const self = this;
    const {
      placeholder,
      onChange,
      ...datepickerExtends
    } = self.getExtendedProps();
    const datepickerOption = Object.assign(
      {},
      DateText.detepickerDefaults,
      { placeholderText: placeholder },
      datepickerExtends
    );
    const classNames = [datepickerExtends.className];
    classNames.push(self.getFormControlClassName());
    if (!datepickerOption.readonly) {
      classNames.push("bg-white");
    }
    datepickerOption.className = classNames
      .filter(v => v)
      .filter((v, i, arr) => arr.indexOf(v) === i)
      .join(" ");
    return datepickerOption;
  }
  renderReadonly() {
    const self = this;
    return <p className="mb-0">{self.getVal() || ""}</p>;
  }
  renderInput() {
    const self = this;
    const datepickerOption = self.getDatepickerOption();
    const val = self.getVal();
    let selected = null;
    if (val) {
      selected = isValid(new Date(val)) ? new Date(val) : null;
    }
    return (
      <div>
        <InputGroup
          onKeyDown={event => {
            // backspaceキーによるブラウザバックを防止
            if (keycode(event) === "backspace") {
              event.preventDefault();
            }
          }}
        >
          <DatePicker
            ref={self.datepickerRef}
            selected={selected}
            onChange={self.onChange}
            {...datepickerOption}
          />
        </InputGroup>
        {self.renderValError()}
      </div>
    );
  }
}
export default DateText;
